'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _clear = require('./clear');

var _clear2 = _interopRequireDefault(_clear);

var _curry = require('./curry');

var _curry2 = _interopRequireDefault(_curry);

var _immutable = require('immutable');

var _reduce2 = require('./internal/_reduce');

var _reduce3 = _interopRequireDefault(_reduce2);

var _set2 = require('./internal/_set');

var _set3 = _interopRequireDefault(_set2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapKeys(keyMapper, subject) {
  var isIterable = _immutable.Iterable.isIterable(subject);
  if (isIterable && !_immutable.Iterable.isKeyed(subject) || !isIterable && subject.constructor !== Object) {
    throw new Error('expected an Object or other Keyed Collection but got `' + subject + '`');
  }
  return (0, _reduce3.default)((0, _clear2.default)(subject), function (acc, value, key) {
    return (0, _set3.default)(keyMapper(key, value, subject), value, acc);
  }, subject);
}

/**
 * Like `map` but transforms an Iterable's keys rather than its values.
 *
 * @example <caption>Can be useful for converting keys of API results to a common type.</caption>
 * import { mapKeys, toString } from 'transmute';
 * const stringifyKeys = mapKeys(toString);
 * const m = Map.of(123, Map(), 456, Map(), 789, Map());
 * stringifyKeys(m).equals(Map.of('123', Map(), '456', Map(), '789', Map()));
 *
 * @param  {Function} keyMapper returns a new key
 * @param  {KeyedIterable} subject
 * @return {KeyedIterable}
 */
exports.default = (0, _curry2.default)(mapKeys);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.3/mapKeys.js
// module id = 377
// module chunks = 0 1